import { render, staticRenderFns } from "./@GenerateReportDetailNew.vue?vue&type=template&id=01448c5a&scoped=true&"
import script from "./@GenerateReportDetailNew.vue?vue&type=script&lang=js&"
export * from "./@GenerateReportDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./@GenerateReportDetailNew.vue?vue&type=style&index=0&id=01448c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01448c5a",
  null
  
)

export default component.exports